export default __webpack_public_path__ + "static/media/download-solid-red.14403304.svg";